// import React, { useState } from 'react'
// import { Link, useNavigate } from 'react-router-dom'
// import boyImg from "../../images/blankPicBoy2.png";
// import gitlImg from "../../images/blankPic3.png";
// import { OnlineMatchContainer } from './OnlineMatchContainer';
// import { toast, ToastContainer } from 'react-toastify';
// import MessengerModal from '../MessengerModel';
// function ProfileContainer({ profileData, unreadCount }) {

//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const gender = localStorage.getItem('gender');
//     const accountType = localStorage.getItem('account_type');
//     const navigate = useNavigate();

//     // Only set username if profileData exists
//     if (profileData && profileData.username) {
//         localStorage.setItem('username', profileData.username);
//     }

//     const getProfileImage = () => {
//   const photo = profileData?.photo;

//   // If backend sends array
//   if (Array.isArray(photo) && photo.length > 0) {
//     return photo[0];
//   }

//   // If backend sends valid string
//   if (typeof photo === "string" && photo.trim() !== "") {
//     return photo;
//   }

//   // Fallback
//   return defaultImage;
// };


//     const defaultImage = gender === 'F' ? gitlImg : boyImg;
//     // const profileImage = profileData && profileData.photo
//     //     ? profileData.photo
//     //     : defaultImage;

//     const profileImage = getProfileImage();

//     const handleMessengerClick = (event) => {
//         event.preventDefault(); // Prevent navigation
//         setIsModalOpen(true); // open modal

//     };
//     return (
//         <div className="col-lg-3 col-12">
//             <div className='leftNav-Container'>

//                 <div className="leftNav">
//                     <div className="leftUser text-center">
//                         <img
//                             src={profileImage}
//                             alt="user img"
//                             className="img-fluid"
//                             onError={(e) => {
//     e.target.onerror = null;
//     e.target.src = defaultImage;
//   }}
//                             style={{
//                                 borderRadius: '50%',
//                                 width: '50px',
//                                 height: '50px',
//                             }}
//                         />

//                         <p className="userName">{profileData && profileData.name ? profileData.name : ''} {profileData && profileData.last_name ? profileData.last_name : ''}</p>
//                         <p className="userID">ID - {profileData && profileData.username ? profileData.username : ''}</p>
//                         <p className="editProfile"><Link to="/view-profile">Edit Profile</Link></p>
//                     </div>
//                     <div className="leftNavLink text-center">
//                         <div className="leftNavLink text-center">
//                             <Link to="/my_matches">Matches</Link><br />
//                             <Link to="/activity">Activity</Link><br />
//                             <Link to="search">Search</Link><br />
//                             <a href="#!" onClick={handleMessengerClick}>
//                                 Messenger{" "}
//                                 {unreadCount > 0 && (
//                                     <span
//                                         style={{
//                                             backgroundColor: "red",
//                                             color: "white",
//                                             borderRadius: "50%",
//                                             padding: "2px 6px",
//                                             fontSize: "12px",
//                                             marginLeft: "5px",
//                                         }}
//                                     >
//                                         {unreadCount}
//                                     </span>
//                                 )}
//                             </a><br />
//                             <Link to="upgrade">Upgrade</Link><br />
//                         </div>
//                     </div>
//                 </div>
//                 {/* <OnlineMatchContainer /> */}
//                 <MessengerModal
//                     open={isModalOpen}
//                     onClose={() => setIsModalOpen(false)} // close modal handler
//                 />
//                 {/* <ToastContainer /> */}
//             </div>
//         </div>

//     )
// }

// export default ProfileContainer






import React, { useState, useEffect} from 'react'
// import { Link, useNavigate } from 'react-router-dom'
import boyImg from "../../images/blankPicBoy2.png";
import gitlImg from "../../images/blankPic3.png";

import matchesIcon from "../../images/matches-icon1.svg";
import activityIcon from "../../images/activity-icon.svg";
import searchIcon from "../../images/search-icon.svg";
import messageIcon from "../../images/messager-icon.svg";
import upgradeIcon from "../../images/upgrade-icon.svg";

import { Link, useNavigate, useLocation } from 'react-router-dom';

// import { OnlineMatchContainer } from './OnlineMatchContainer';
import { toast, ToastContainer } from 'react-toastify';
import MessengerModal from '../MessengerModel';



function ProfileContainer({ profileData, unreadCount }) {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const gender = localStorage.getItem('gender');
    const accountType = localStorage.getItem('account_type');
    const navigate = useNavigate();

    const location = useLocation();
    const currentPath = location.pathname;

useEffect(() => {
  if (profileData?.username) {
    localStorage.setItem("username", profileData.username);
  }
}, [profileData]);


    const defaultImage = gender === 'F' ? gitlImg : boyImg;
    const profileImage = profileData && profileData.photo
        ? profileData.photo
        : defaultImage;
    const handleMessengerClick = (event) => {
        event.preventDefault();
        setIsModalOpen(true); // open modal
    };



// Detect Active styling
const isActive = (path) => currentPath === path;

const navContainer = {
    padding: "10px 40px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
};

// Base Row Style
const navRowBase = {
    display: "flex",
    alignItems: "center",
    gap: "18px",
    fontSize: "15px",
    fontWeight: 500,
    textDecoration: "none",
    height: "26px",
    cursor: "Pointer",
    position: "relative",
};

// Active row highlight (gradient bg)
const activeBg = {
     background: "linear-gradient(-90deg, rgba(217,217,217,0), rgba(255,60,60,0.3) 46.89%, rgba(247,140,37,0.3) 95.69%)",
    transform: "rotate(0deg)",
    transformOrigin: "0 0",

    position: "relative",

    padding: "10px 20px",
    width: "100%",
    height: "46px",
    display: "flex",
    alignItems: "center",
};

const leftActiveBar = {
    width: "5px",
    height: "35px",
    background: "linear-gradient(180deg, #f78c25, #ff3c3c)",
    borderRadius: "4px",
    position: "absolute",
    left: "-15px",
};

// Gradient color SVG icon
const gradientIcon = (icon) => ({
    mask: `url(${icon}) no-repeat center`,
    WebkitMask: `url(${icon}) no-repeat center`,
    background: "linear-gradient(180deg, #f78c25, #ff3c3c)",
    width: "24px",
    height: "22px",
});

const blackIcon = (icon) => ({
    mask: `url(${icon}) no-repeat center`,
    WebkitMask: `url(${icon}) no-repeat center`,
    background: "#000",     // solid black
    width: "24px",
    height: "22px",
});



return (
    <div className="col-lg-3 col-12">
        <div
            style={{
                width: "100%",
                background: "#fff",
                borderRadius: "20px",
                border: "1px solid #e3e3e3",
                boxShadow: "2px 2px 7px rgba(166,166,166,0.4)",
                paddingBottom: "25px",
                overflow: "hidden",
                position: "sticky",
                top: "125px",
                maxHeight: "calc(100vh - 40px)",
                overflowY: "auto",
            }}
        >

            {/* Top Cover Image */}
         


<div
 
  style={{
    width: "100%",
    height: "262px",
    padding: "20px",
    borderRadius: "20px",
    background: "#fff",          // ✅ white padding background
    boxSizing: "border-box",
    
  }}
>
  {/* IMAGE WRAPPER (inside padding) */}
  <div
  onClick={() => navigate("/view-profile")}
    style={{
      width: "100%",
      height: "100%",
      position: "relative",
      overflow: "hidden",
      borderRadius: "16px",       // slightly smaller for inner crop
      cursor: "pointer",
    }}
  >
    {/* ---- BLURRED BACKGROUND LAYER ---- */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        backgroundImage: `url("${profileImage}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: "blur(18px)",
        transform: "scale(1.2)",
        zIndex: 1,
      }}
    />

    {/* ---- MAIN IMAGE (CLEAR) ---- */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        backgroundImage: `url("${profileImage}")`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        zIndex: 2,
      }}
    />
  </div>
</div>


           


{/* Navigation */}
<div style={navContainer}>

    {/* Matches */}
    <Link
        to="/my_matches"
        style={{
            ...navRowBase,
            ...(isActive("/my_matches") ? activeBg : {}),
        }}
    >
        {isActive("/my_matches") && <div style={leftActiveBar}></div>}
        
        <div style={isActive("/my_matches") ? gradientIcon(matchesIcon) : blackIcon(matchesIcon)} />
        
        <span
            style={
                isActive("/my_matches")
                    ? {
                          background:
                              "linear-gradient(90deg, #f78c25, #ff3c3c)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                      }
                    : { color: "#000" }
            }
        >
            Matches
        </span>
    </Link>

    {/* Activity */}
    <Link
        to="/activity"
        style={{
            ...navRowBase,
            ...(isActive("/activity") ? activeBg : {}),
        }}
    >
        {isActive("/activity") && <div style={leftActiveBar}></div>}
        
        <div style={isActive("/activity") ? gradientIcon(activityIcon) : blackIcon(activityIcon)} />

        <span
            style={
                isActive("/activity")
                    ? {
                          background:
                              "linear-gradient(90deg, #f78c25, #ff3c3c)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                      }
                    : { color: "#000" }
            }
        >
            Activity
        </span>
    </Link>

    {/* Search */}
    <Link
        to="/search"
        style={{
            ...navRowBase,
            ...(isActive("/search") ? activeBg : {}),
        }}
    >
        {isActive("/search") && <div style={leftActiveBar}></div>}
        
        <div style={isActive("/search") ? gradientIcon(searchIcon) : blackIcon(searchIcon)} />

        <span
            style={
                isActive("/search")
                    ? {
                          background:
                              "linear-gradient(90deg, #f78c25, #ff3c3c)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                      }
                    : { color: "#000" }
            }
        >
            Search
        </span>
    </Link>

    {/* Messenger */}
    <a
        onClick={handleMessengerClick}
        style={{
            ...navRowBase,
            ...(isActive("/messenger") ? activeBg : {}),
        }}
    >
        {isActive("/messenger") && <div style={leftActiveBar}></div>}
        
        <div style={isActive("/messenger") ? gradientIcon(messageIcon) : blackIcon(messageIcon)} />

        <span
            style={
                isActive("/messenger")
                    ? {
                          background:
                              "linear-gradient(90deg, #f78c25, #ff3c3c)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                      }
                    : { color: "#000" }
            }
        >
            Messenger
        </span>

        {unreadCount > 0 && (
            <span
                style={{
                    background: "red",
                    color: "#fff",
                    borderRadius: "50%",
                    padding: "2px 7px",
                    fontSize: "12px",
                    marginLeft: "8px",
                }}
            >
                {unreadCount}
            </span>
        )}
    </a>

    {/* Upgrade */}
    <Link
        to="/upgrade"
        style={{
            ...navRowBase,
            ...(isActive("/upgrade") ? activeBg : {}),
        }}
    >
        {isActive("/upgrade") && <div style={leftActiveBar}></div>}
        
        <div style={isActive("/upgrade") ? gradientIcon(upgradeIcon) : blackIcon(upgradeIcon)} />

        <span
            style={
                isActive("/upgrade")
                    ? {
                          background:
                              "linear-gradient(90deg, #f78c25, #ff3c3c)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                      }
                    : { color: "#000" }
            }
        >
            Upgrade
        </span>
    </Link>
</div>



            {/* Modals */}
            <MessengerModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
            {/* <ToastContainer /> */}
        </div>
    </div>
);


}

export default ProfileContainer


